/**
 * 是否微信
 * @returns
 */
export default () => {
	var ua = navigator.userAgent.toLowerCase();
	return ua.match(/MicroMessenger/i) == "micromessenger";
};
